<script setup lang="ts">
import { getMaxSelectablePreviousDay } from '@/services/functions';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { ja } from 'date-fns/locale';
import { computed } from 'vue';

const emits = defineEmits(['update:modelValue', 'search']);

const props = defineProps<{
  modelValue: Date[]
  maxRange: number
  format: string
  isError: boolean
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});
</script>
<template>
  <div
    class="w-100 range-date-picker"
    :class="{ 'range-date-picker-error': props.isError }"
  >
    <VueDatePicker
      v-model="modelValue"
      class="w-100"
      teleport="body"
      :locale="ja"
      :enable-time-picker="false"
      :formats="{ input: props.format }"
      :range="{
        maxRange: props.maxRange
      }"
      :min-date="getMaxSelectablePreviousDay()"
      auto-apply
      :clearable="false"
      multi-calendars
    >
      <template
        #clear-icon="{ clear }"
      >
        <div
          @click="clear"
        />
      </template>
    </VueDatePicker>
  </div>
</template>

<style scoped>
:deep(.range-date-picker-error .dp__input) {
  border-color: #dc3545 !important;
}

.range-date-picker-error-message {
  display: block;
  margin-top: 4px;
  color: #dc3545;
}
</style>
